import enabledModules from '@strongio/pretrained-dashboard/modules.json';

// eslint-disable-next-line import/prefer-default-export
export function isModuleEnabled(moduleName) {
  return enabledModules.includes(moduleName);
}